import axios, { AxiosError, AxiosResponse } from 'axios';
import { Environment } from '../environment/environment';
import { CurrentPage } from '../pages/currentPage';
import { HTTP_STATUS_FORBIDDEN } from '../constants/http';

export function configureHttpAuth() {
    axios.interceptors.request.use(function setupAxiosRequest(config) {
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['X-Language'] = window.app.config.language;

        if (window.app.user_huid) {
            config.headers['X-Current-Account'] = window.app.user_huid;
        }

        if (Environment.isSocial()) {
            config.headers['X-Session-Token'] = window.app.session.id;
            config.headers['X-Force-Session'] = '1';
        }
        return config;
    });

    axios.interceptors.response.use(
        function handleAxiosRequestResponse(response: AxiosResponse) {
            return response;
        },
        function handleAxiosRequestReject(axiosError: AxiosError) {
            const hasReloadHeader = axiosError?.response?.headers?.['x-reload'] === '1';

            if (axiosError?.response?.status === HTTP_STATUS_FORBIDDEN && hasReloadHeader) {
                CurrentPage.reload();
            }

            throw axiosError;
        }
    );

    $.ajaxSetup({
        beforeSend: function setupJqueryAjaxBeforeSend(xhr) {
            if (Environment.isSocial()) {
                xhr.setRequestHeader('X-Session-Token', window.app.session.id);
                xhr.setRequestHeader('X-Force-Session', '1');
            }
            xhr.setRequestHeader('X-Language', window.app.config.language);
            if (window.app.user_huid) {
                xhr.setRequestHeader('X-Current-Account', String(window.app.user_huid));
            }
        },
        complete: function handleJqueryAjaxComplete(xhr) {
            if (xhr.status === HTTP_STATUS_FORBIDDEN && xhr.getResponseHeader('X-Reload') === '1') {
                CurrentPage.reload();
            }
        }
    });
}
